export const serviceData = {
	heading: {
		title: 'Frequently Asked Questions',
		subtitle: 'Who are in extremely love with eco friendly system.',
	},

	serviceList: [
		{
			title: 'Expert Technicians',
			txt:
				'Usage of the Internet is becoming more common due to rapid advancement of technology and power.',
		},
		{
			title: 'Professional Service',
			txt:
				'Usage of the Internet is becoming more common due to rapid advancement of technology and power.',
		},
		{
			title: 'Great Support',
			txt:
				'Usage of the Internet is becoming more common due to rapid advancement of technology and power.',
		},
		{
			title: 'Technical Skills',
			txt:
				'Usage of the Internet is becoming more common due to rapid advancement of technology and power.',
		},
		{
			title: 'Highly Recomended',
			txt:
				'Usage of the Internet is becoming more common due to rapid advancement of technology and power.',
		},
		{
			title: 'Positive Reviews',
			txt:
				'Usage of the Internet is becoming more common due to rapid advancement of technology and power.',
		},
	],
};
